import { useState, useEffect } from 'react';
import { Typography, CircularProgress } from '@mui/material';
import { useUser, useAuth } from '@clerk/clerk-react';

import * as Api from '../Api';

function timeout(delay) {
  return new Promise((res) => setTimeout(res, delay));
}

function Status({ intent, interval }) {
  const { user } = useUser();
  const [message, setMessage] = useState('Verifying card details...');
  const [showLoader, setShowLoader] = useState(true);
  const { getToken } = useAuth();

  // TODO do i need to passin interval as param, or can i just use it from state?
  const subscribe = async (getToken, user_id, pm_id, interval) => {
    try {
      await Api.call(
        await getToken(),
        'POST',
        `subscription?user_id=${user_id}&pm_id=${pm_id}&interval=${interval}`,
      );
      setMessage('All done! One moment please...');
      await timeout(2000);
      window.location.reload();
    } catch (err) {
      // TODO
    }
  };

  useEffect(() => {
    if (!intent) {
      return;
    }
    //TODO if bad input (such as empty card number) this spinner is shown
    //ideally just show message 'please correct and try again' without the spinner, because nothing is actually loading
    //already messed with this and wasted a bunch of time, so just leaving it for now
    setMessage('Verifying card details...');
    setShowLoader(true);

    const user_id = user.publicMetadata.stripe_id;

    // card is saved, image applied to it, now subscribe
    // https://stripe.com/docs/payments/payment-methods#payment-notification
    switch (intent.status) {
      case 'succeeded':
        setMessage('Applying retainur...');
        subscribe(getToken, user_id, intent.payment_method, interval);
        break;

      case 'processing':
        setMessage('Payment processing. Check your dashboard or try again later.');
        setShowLoader(false);
        break;

      case 'requires_payment_method':
        setMessage('Payment failed. Please try another card.');
        setShowLoader(false);
        break;

      default:
        setMessage('Something went wrong.');
        setShowLoader(false);
        break;
    }
  }, [intent]);

  return (
    <>
      <Typography>{message}</Typography>
      {showLoader && <CircularProgress />}
    </>
  );
}

export default Status;
